import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <div className='app-layout'>
      <Outlet />
    </div>
  );
}

export default Layout;
